/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  RecordInstallIntentRequestBody,
  RecordInstallIntentRequestBody$Outbound,
  RecordInstallIntentRequestBody$outboundSchema,
} from "../components/recordinstallintentrequestbody.js";

export type RecordPlatformMCPInstallIntentSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type RecordPlatformMCPInstallIntentRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  recordInstallIntentRequestBody: RecordInstallIntentRequestBody;
};

/** @internal */
export type RecordPlatformMCPInstallIntentSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const RecordPlatformMCPInstallIntentSecurity$outboundSchema:
  z.ZodMiniType<
    RecordPlatformMCPInstallIntentSecurity$Outbound,
    RecordPlatformMCPInstallIntentSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function recordPlatformMCPInstallIntentSecurityToJSON(
  recordPlatformMCPInstallIntentSecurity:
    RecordPlatformMCPInstallIntentSecurity,
): string {
  return JSON.stringify(
    RecordPlatformMCPInstallIntentSecurity$outboundSchema.parse(
      recordPlatformMCPInstallIntentSecurity,
    ),
  );
}

/** @internal */
export type RecordPlatformMCPInstallIntentRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  RecordInstallIntentRequestBody: RecordInstallIntentRequestBody$Outbound;
};

/** @internal */
export const RecordPlatformMCPInstallIntentRequest$outboundSchema:
  z.ZodMiniType<
    RecordPlatformMCPInstallIntentRequest$Outbound,
    RecordPlatformMCPInstallIntentRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      recordInstallIntentRequestBody:
        RecordInstallIntentRequestBody$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        recordInstallIntentRequestBody: "RecordInstallIntentRequestBody",
      });
    }),
  );

export function recordPlatformMCPInstallIntentRequestToJSON(
  recordPlatformMCPInstallIntentRequest: RecordPlatformMCPInstallIntentRequest,
): string {
  return JSON.stringify(
    RecordPlatformMCPInstallIntentRequest$outboundSchema.parse(
      recordPlatformMCPInstallIntentRequest,
    ),
  );
}
